import type { Icon } from '../../../src/lib/types'
export const mdiHomeVariant: Icon = {
  "id": "home-variant",
  "name": "Home Variant",
  "path": "M12,3L20,9V21H15V14H9V21H4V9L12,3Z",
  "as": [
    "house-variant"
  ],
  "tags": [
    "Home Automation"
  ]
}
export default mdiHomeVariant